export default __webpack_public_path__ + "static/media/notes.06faa7f9.svg";